//libraries
import Vue from 'vue'

let resource = 'permission'
let resourceName = 'permiso'
let resourceNamePlural = 'permisos'

let state = {}

state[resource + 's'] = []

//functions receive state
let getters = {}

//functions receive context and params
let actions = {
  async all ({ commit }, { params = {}, callback = () => {} }) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`${resource}`, { params })

      if(!res.data.success) throw new Error('Error obteniendo todos los permisos')

      commit('setItems', res.data.resource)
      callback(res.data)
    } catch (e) {
      const dataError = { error: `Ocurrió un error obteniendo ${resourceNamePlural}.`}
      
      console.error(e)
      callback(dataError)
    }
  },
  async get ({ commit }, { params = {}, callback = () => {} }) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, { params })

      if (!res.data.success) throw new Error(`Error obteniendo ${resourceName}`)
      
      callback(res.data)
    } catch (e) {
      const dataError = { error: `Ocurrió un error obteniendo ${resourceName}.`}
      
      console.error(e)
      callback(dataError)
    }
  },
  async create ({ commit }, { params = {}, callback = () => {} }) {
    try {
      let res = await Vue.request.post(`${resource}`, params)

      if (!res.data.success) throw new Error(`Error creando ${resourceName}.`)

      callback(res.data)
    } catch (e) {
      const dataError = { error: `Ocurrió un error creando ${resourceName}.`}

      console.error(e)
      callback(dataError)
    }
  },
  async update ({ commit }, { params = {}, callback = () => {} }) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)

      if (!res.data.success) throw new Error(`Error actualizando ${resourceName}.`)
    
      callback(res.data)
    } catch (e) {
      const dataError = { error: `Ocurrió un error actualizando ${resourceName}.`}

      console.error(e)
      callback(dataError)
    }
  },
  async destroy ({ commit }, { params = {}, callback = () => {} }) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, { data: params })

      if(!res.data.success) throw new Error(`Error eliminando ${resourceName}.`)

      callback(res.data)
    } catch (e) {
      const dataError = { error: `Ocurrió un error eliminando ${resourceName}.`}

      console.error(e)
      callback(dataError)
    }
  },
  async admin ({ commit }, { params = {}, callback = () => {} }) {
    try {
      let res = await Vue.request.get(`${resource}/admin`, { params })
      res.data.resource = res.data.resource || []

      if (!res.data.success && params.callback) throw new Error(`Error obteniendo ${resourceName}.`)

      callback(res.data)
    } catch (e) {
      const dataError = { error: `Ocurrió un error obteniendo ${resourceName}.`}

      console.error(e)
      callback(dataError)
    }
  },
  async associatePermission ({ commit }, { params = {}, callback = () => {} }) {
    try {
      let res = await Vue.request.post(`${resource}/admin`, params)

      if (!res.data.success) throw new Error(`Error asociando ${resourceName}.`)
      
      callback(res.data)
    } catch (e) {
      const dataError = { error: `Ocurrió un error asociando ${resourceName}.`}

      console.error(e)
      callback(dataError)
    }
  },
  async removePermission ({ commit }, { params = {}, callback = () => {} }) {
    try {
      let res = await Vue.request.delete(`${resource}/admin`, {data: params})

      if(!res.data.success) throw new Error(`Error desasociando ${resourceName}.`)
      
      callback(res.data)
    } catch (e) {
      const dataError = { error: `Ocurrió un error desasociando ${resourceName}.`}

      console.error(e)
      callback(dataError)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
